export enum ChatsMode {
  Chats = 'Chats',
  ArchivedChats = 'ArchivedChats',
}
